import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
import { BsExclamationCircleFill } from 'react-icons/bs';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

interface BotEngineSelectorProps {
  texts: string[];
}

const KnowledgeBaseAlert: React.FC<BotEngineSelectorProps> = ({ texts }) => {
  const { t } = useTranslation();

  return (
    <div className="tw-pl-2 tw-pr-3 tw-pt-2 tw-py-1 tw-bg-orange-50 tw-rounded-xl tw-justify-start tw-items-start tw-gap-1.5 tw-inline-flex tw-mt-2">
      <div className="tw-py-0.5 tw-justify-start tw-items-center tw-gap-2.5 tw-flex">
        <BsExclamationCircleFill className="tw-text-[#D97706]" />
      </div>
      <div className="tw-grow tw-shrink tw-basis-0 tw-text-amber-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
        {texts.map((text, index) => (
          <p key={index}>{ReactHtmlParser(t(text))}</p>
        ))}
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(KnowledgeBaseAlert);
